/**
 * Static configuration for Dikaios1517's Theology Blog.
 */

/** The blog owner's public key (hex), decoded from their npub. */
export const BLOG_OWNER_PUBKEY =
  'b7274d28e3e983bf720db4b4a12a31f5c7ef262320d05c25ec90489ac99628cb';

/** The blog owner's npub. */
export const BLOG_OWNER_NPUB =
  'npub1kun5628raxpm7usdkj62z2337hr77f3ryrg9cf0vjpyf4jvk9r9smv3lhe';

/** The hashtag that identifies articles belonging to this blog. Compared case-insensitively. */
export const BLOG_HASHTAG = 'Theology';

/** Human-readable blog title. */
export const BLOG_TITLE = "Dikaios1517's Theology Blog";

/**
 * Well-known public indexer relays where users' NIP-65 (kind 10002) relay lists
 * are most likely to be found. Used to bootstrap the outbox model.
 */
export const INDEX_RELAYS = [
  'wss://purplepag.es/',
  'wss://indexer.coracle.social/',
  'wss://user.kindpag.es/',
  'wss://relay.nostr.band/',
];

/**
 * Fallback relays to try if a user has no discoverable kind 10002, or as a
 * supplement to their advertised relays.
 */
export const FALLBACK_RELAYS = [
  'wss://relay.damus.io/',
  'wss://relay.primal.net/',
  'wss://nos.lol/',
];
